export type Web3NetworkMode = 'mainnet' | 'testnet'

/**
 * 解析当前 Web3 网络模式：
 * 1. 优先使用 VITE_WEB3_NETWORK（mainnet | testnet）
 * 2. 否则 VITE_APP_ENV === production → mainnet
 * 3. 否则开发/测试环境 → testnet
 */
export function getWeb3NetworkMode(): Web3NetworkMode {
  const explicit = import.meta.env.VITE_WEB3_NETWORK?.trim().toLowerCase()
  if (explicit === 'mainnet' || explicit === 'testnet') {
    return explicit
  }

  const appEnv = import.meta.env.VITE_APP_ENV?.trim().toLowerCase()
  if (appEnv === 'production') {
    return 'mainnet'
  }

  return 'testnet'
}

export const web3NetworkMode = getWeb3NetworkMode()

export const isWeb3Testnet = web3NetworkMode === 'testnet'

if (import.meta.env.DEV) {
  console.info(`[web3] 网络模式: ${web3NetworkMode} (${isWeb3Testnet ? '测试网' : '主网'})`)
}
